import { HttpStatusCode, isAxiosError } from "axios";

export type TemplateUseFailure =
    | { kind: "template_changed" }
    | { kind: "plan_already_exists"; existingPlanId?: string }
    | { kind: "unavailable" }
    | { kind: "target_year_not_after_diagnostic" }
    | { kind: "throttled" }
    | { kind: "outage" }
    | { kind: "unknown" };

export const classifyTemplateUseFailure = (error: unknown): TemplateUseFailure => {
    if (!isAxiosError(error) || !error.response) {
        return { kind: "unknown" };
    }

    const { status, data } = error.response;
    const reasons: Record<string, unknown> = typeof data?.reasons === "object" && data.reasons ? data.reasons : {};

    if (status === HttpStatusCode.Conflict && reasons.templateVersion === "template_changed") {
        return { kind: "template_changed" };
    }

    if (status === HttpStatusCode.Conflict && reasons.proposal === "plan_already_exists") {
        return {
            kind: "plan_already_exists",
            ...(typeof data.existingPlanId === "string" ? { existingPlanId: data.existingPlanId } : {}),
        };
    }

    if (status === HttpStatusCode.Conflict && reasons.proposal === "unavailable") {
        return { kind: "unavailable" };
    }

    if (status === HttpStatusCode.UnprocessableEntity && reasons.endCampaignId === "target_year_not_after_diagnostic") {
        return { kind: "target_year_not_after_diagnostic" };
    }

    if (status === HttpStatusCode.TooManyRequests) {
        return { kind: "throttled" };
    }

    if (status === HttpStatusCode.ServiceUnavailable) {
        return { kind: "outage" };
    }

    return { kind: "unknown" };
};

export const isCreationOutcomeUncertain = (error: unknown) =>
    !isAxiosError(error) ||
    !error.response ||
    error.response.status >= HttpStatusCode.InternalServerError ||
    error.response.status === HttpStatusCode.RequestTimeout;
